import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import villasMeta from "../../data/villasMeta";
import { getVillaHeroImage } from "../../data/villaHeroImages";
import { buildStructuredDataForPath } from "../../utils/structuredData";
import StructuredData from "./StructuredData";

function SiteStructuredData() {
  const { pathname } = useLocation();

  const data = useMemo(() => {
    const slugMatch = pathname.match(/^\/villa\/([^/]+)/);
    const slug = slugMatch?.[1];
    const villa = slug ? villasMeta.find((item) => item.slug === slug) : null;
    const villaImageUrl = slug ? getVillaHeroImage(slug) : null;

    return buildStructuredDataForPath(pathname, villa, villaImageUrl);
  }, [pathname]);

  return <StructuredData data={data} />;
}

export default SiteStructuredData;
